import { MapSearchInput } from '../../../shared/utils/queryUtils'

export const usersTableFields: MapSearchInput['path'] = {
    name: ['businessName', 'fullName', 'businessIdentifier.value'],
    email: 'email'
}
